import _ from "lodash"
import ImageRepository from "../repositories/ImageRepository"

export default class UploadAdapter {
    constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then( file => new Promise( async ( resolve, reject ) => {
                // this._initRequest();
                // this._initListeners( resolve, reject, file );
                // this._sendRequest( file );
                let response = await ImageRepository.uploads([file])

                if (response.success) {
                    let data = _.get(response, 'data', [])
                    
                    if (data.length) {
                        resolve({
                            default: _.get(data[0], 'path', '') ? process.env.VUE_APP_API.replace('/api', '') + _.get(data[0], 'path', '') : ''
                        })
                    } else {
                        resolve({
                            default: ''
                        })
                    }
                } else {
                    resolve({
                        default: ''
                    })
                }
            } ) );
    }

    // // Aborts the upload process.
    // abort() {
    //     if ( this.xhr ) {
    //         this.xhr.abort();
    //     }
    // }

    // // Initializes the XMLHttpRequest object using the URL passed to the constructor.
    // _initRequest() {
    //     const xhr = this.xhr = new XMLHttpRequest();

    //     xhr.open( 'POST', process.env.VUE_APP_UPLOAD_IMAGE_URL, true );
    //     xhr.responseType = 'json';
    // }

    // // Initializes XMLHttpRequest listeners.
    // _initListeners( resolve, reject, file ) {
    //     const xhr = this.xhr;
    //     const loader = this.loader;
    //     const genericErrorText = `Couldn't upload file: ${ file.name }.`;

    //     xhr.addEventListener( 'error', () => reject( genericErrorText ) );
    //     xhr.addEventListener( 'abort', () => reject() );
    //     xhr.addEventListener( 'load', () => {
    //         const response = xhr.response;

    //         if ( !response || response.error ) {
    //             return reject( response && response.error ? response.error.message : genericErrorText );
    //         }

    //         resolve( {
    //             default: response.url
    //         } );
    //     } );

    //     if ( xhr.upload ) {
    //         xhr.upload.addEventListener( 'progress', evt => {
    //             if ( evt.lengthComputable ) {
    //                 loader.uploadTotal = evt.total;
    //                 loader.uploaded = evt.loaded;
    //             }
    //         } );
    //     }
    // }

    // // Prepares the data and sends the request.
    // _sendRequest( file ) {
    //     // Prepare the form data.
    //     const data = new FormData();

    //     data.append( 'upload', file );

    //     // Send the request.
    //     this.xhr.send( data );
    // }
}